"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EDIT_TYPE = exports.ELEMENT_TYPE = exports.GUIDE_TYPE = exports.RENDER_STATE = exports.RENDER_TYPE = exports.SHAPE = exports.GEOJSON_TYPE = void 0;
var GEOJSON_TYPE;
exports.GEOJSON_TYPE = GEOJSON_TYPE;

(function (GEOJSON_TYPE) {
  GEOJSON_TYPE["POINT"] = "Point";
  GEOJSON_TYPE["LINE_STRING"] = "LineString";
  GEOJSON_TYPE["POLYGON"] = "Polygon";
})(GEOJSON_TYPE || (exports.GEOJSON_TYPE = GEOJSON_TYPE = {}));

var SHAPE;
exports.SHAPE = SHAPE;

(function (SHAPE) {
  SHAPE["POINT"] = "Point";
  SHAPE["LINE_STRING"] = "LineString";
  SHAPE["POLYGON"] = "Polygon";
  SHAPE["RECTANGLE"] = "Rectangle";
  SHAPE["CIRCLE"] = "Circle";
})(SHAPE || (exports.SHAPE = SHAPE = {}));

var RENDER_TYPE;
exports.RENDER_TYPE = RENDER_TYPE;

(function (RENDER_TYPE) {
  RENDER_TYPE["POINT"] = "Point";
  RENDER_TYPE["LINE_STRING"] = "LineString";
  RENDER_TYPE["POLYGON"] = "Polygon";
  RENDER_TYPE["RECTANGLE"] = "Rectangle";
})(RENDER_TYPE || (exports.RENDER_TYPE = RENDER_TYPE = {}));

var RENDER_STATE;
exports.RENDER_STATE = RENDER_STATE;

(function (RENDER_STATE) {
  RENDER_STATE["INACTIVE"] = "INACTIVE";
  RENDER_STATE["UNCOMMITTED"] = "UNCOMMITTED";
  RENDER_STATE["SELECTED"] = "SELECTED";
  RENDER_STATE["HOVERED"] = "HOVERED";
  RENDER_STATE["CLOSING"] = "CLOSING";
})(RENDER_STATE || (exports.RENDER_STATE = RENDER_STATE = {}));

var GUIDE_TYPE;
exports.GUIDE_TYPE = GUIDE_TYPE;

(function (GUIDE_TYPE) {
  GUIDE_TYPE["TENTATIVE"] = "tentative";
  GUIDE_TYPE["EDIT_HANDLE"] = "editHandle";
  GUIDE_TYPE["CURSOR_EDIT_HANDLE"] = "cursorEditHandle";
})(GUIDE_TYPE || (exports.GUIDE_TYPE = GUIDE_TYPE = {}));

var ELEMENT_TYPE;
exports.ELEMENT_TYPE = ELEMENT_TYPE;

(function (ELEMENT_TYPE) {
  ELEMENT_TYPE["FEATURE"] = "feature";
  ELEMENT_TYPE["FILL"] = "fill";
  ELEMENT_TYPE["SEGMENT"] = "segment";
  ELEMENT_TYPE["EDIT_HANDLE"] = "editHandle";
  ELEMENT_TYPE["TOOLTIP"] = "tooltip";
})(ELEMENT_TYPE || (exports.ELEMENT_TYPE = ELEMENT_TYPE = {}));

var EDIT_TYPE;
exports.EDIT_TYPE = EDIT_TYPE;

(function (EDIT_TYPE) {
  EDIT_TYPE["ADD_FEATURE"] = "addFeature";
  EDIT_TYPE["ADD_POSITION"] = "addPosition";
  EDIT_TYPE["REMOVE_POSITION"] = "removePosition";
  EDIT_TYPE["ADD_TENTATIVE_POSITION"] = "addTentativePosition";
  EDIT_TYPE["MOVE_POSITION"] = "movePosition";
  EDIT_TYPE["FINISH_MOVE_POSITION"] = "finishMovePosition";
})(EDIT_TYPE || (exports.EDIT_TYPE = EDIT_TYPE = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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